export enum Roles {
    ADMIN = 'ROLE_ADMIN',
    REPRESENTATIVE = 'ROLE_REPRESENTATIVE',
    SUPER_ADMIN = 'ROLE_SUPER_ADMIN',
    USER_MANAGER = 'ROLE_USER_MANAGER'
}